exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\ndiv.bstest {\n\twidth: 90%;\n}\ndiv.bstest .container td{\n\twidth: 36%\n}\ndiv.bstest .container{\n\tmax-width: 1140px;\n\tmargin-left: 60px;\n}\n.table td {\n\tpadding:0.8em 0.75em;\n}\n", ""]);



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-26704dee","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Management/Code/List.vue
// module id = Y4xb
// module chunks = 1